import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Auth, ProgressBar, QRCode } from '@spendlevel/shared-login-frontend';
import { CodeInput } from "@spendlevel/shared-login-frontend";

function MfaSetup() {
    const [qrCode, setQRCode] = useState('');
    const [errorMsgHidden, setErrorMsgHidden] = useState('none');
    const [errorMsg, setErrorMsg] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const [showProgressBar, setShowProgressBar] = useState(false);

    useEffect(() => {
        document?.querySelector('html')?.setAttribute('data-bs-theme', 'dark');
        
        if (!location.state?.mfaSetupUrl) {
            navigate('/');
        }

        setQRCode(location.state?.mfaSetupUrl);
    }, [location.state?.mfaSetupUrl, navigate]);

    const handleCodeChanged = async (value: string) => {
        setErrorMsgHidden('none');
    }

    const handleCodeCompleted = async (value: string) => {
        setShowProgressBar(true);

        const result = await Auth.verifyMFACode('admin', value);
        
        setShowProgressBar(false);

        if (result?.status === 'Success') {
            //window.location.href = '/secure';
            navigate('/iframe');
        }

        if (result?.errorMsg) {
            setErrorMsg(result.errorMsg);
            setErrorMsgHidden('contents');
            return false;
        }

        return true;
    }
    
    return (
        <div className="login login-v2 fw-bold">
            <div className="login-cover">
                <div className="login-cover-img" style={{ backgroundImage: 'url(/assets/login-bg-17.jpg)' }}></div>
                <div className="login-cover-bg">{showProgressBar && <ProgressBar/>}</div>
            </div>

            <div className="login-container">
                <div className="login-header">
                    <div className="brand">
                        <div className="d-flex align-items-center">
                            <span className="logo"></span> <b>SpendLevel</b> Admin
                        </div>
                        <div className="d-flex align-items-center">
                            <span>Keep Your Account Secure</span>
                        </div>
                        <div className="d-flex align-items-center">
                            <small>Your organization requires you to setup the following method to prove who you are using Google Authenticator</small>
                        </div>
                        <div className="d-flex align-items-center" style={{paddingTop: '15px'}}>
                            <span>Scan the QR code</span>
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="qrcodeImage" style={{justifyContent: 'center', paddingTop: '8px'}}>
                                <QRCode value={qrCode} />
                            </div>
                        </div>
                        <small>Have your OTP code? Please enter it here.</small>
                    </div>
                </div>
                <div className="login-content">
                    <div>
                        <CodeInput onCodeChanged={handleCodeChanged} onCodeCompleted={handleCodeCompleted} />
                    </div>
                </div>
                <div style={{justifyContent: 'center'}}>
                    <span style={{textAlign: 'center', display: errorMsgHidden}}>
                        <div className="alert alert-danger" style={{border: '1px solid #ff9d9a', fontWeight: '400 !important'}}>Authorization failed.  { errorMsg }.</div>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default MfaSetup;